import React from 'react';
import PropTypes from 'prop-types';

export const FocusableSpan = ({
  className,
  ariaLabel,
  children,
  tabIndex = 0
}) => (
  <span className={className} aria-label={ariaLabel} tabIndex={tabIndex}>
    {children}
  </span>
);

FocusableSpan.propTypes = {
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  tabIndex: PropTypes.number
};

export default FocusableSpan;
